// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-previewer .l-list {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.file-previewer .l-list .l-item {\n  width: 20vw;\n  height: 20vw;\n  background: #f7f8fa;\n  margin-left: 2.667vw;\n}\n.file-previewer .l-list .l-item img {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n}\n", ""]);
// Exports
module.exports = exports;
